module.exports = __webpack_public_path__ + "img/gender_white.7222442.svg";